import axios from 'axios';
import config from '../_helpers/_config'

export const authService = {
    login,
    logout
};

async function login(username, password) {
    password = window.btoa(password);
    return axios({
        method: 'post',
        url: `${config.API_LOCATION}/authuser/login`,
        headers: { 'Content-Type': 'application/json' },
        data: JSON.stringify({ username, password })
      }); 
}

function logout() {
    localStorage.removeItem('viewer-user');
}